import { PROJECTS_SUBSCRIPTIONS_REDUCER_KEYS } from '../reducers/projectSubscriptionsReducerKeys'

export const getProjectSubscriptions = projectId => state => {
  return state.getIn([
    PROJECTS_SUBSCRIPTIONS_REDUCER_KEYS.REDUCER,
    PROJECTS_SUBSCRIPTIONS_REDUCER_KEYS.BY_ID,
    projectId,
  ])
}
